module.exports = __webpack_public_path__ + "img/mine_xiaofei_jinkela.a7342cf9.png";